<template>
  <v-container class="container--max py-6">
    <v-row>
      <v-col cols="12" md="9">
        <v-subheader class="text-overline primary--text">
          <v-icon dense color="grey lighten-2" left class="d-none d-sm-flex">mdi-access-point</v-icon>
          <span v-html="today"></span>
        </v-subheader>
        <v-card class="mb-6X" :href="featuredPost.link" flat>
          <v-img v-if="featuredPost.image" :src="featuredPost.image" :aspect-ratio="21/10" cover></v-img>
          <v-card-title v-html="featuredPost.title" class="ch-post__title font-weight-bold text--caslon"></v-card-title>
          <v-card-subtitle class="primary--text pt-1 pb-1" v-html="featuredPost.category.name"></v-card-subtitle>
          <v-card-text v-html="featuredPost.excerpt"></v-card-text>
        </v-card>
      </v-col>
<!--       <v-col cols="12" md="4" class="mt-n4">
        <v-card class="mb-2" v-for="(item, i) in otherItems" :key="i" :href="item.link" flat>
          <v-card-title v-html="item.title" class="ch-post__title ch-post__subtitle text--caslon"></v-card-title>
          <v-card-subtitle class="primary--text pt-1" v-html="item.category.name"></v-card-subtitle>
        </v-card>
      </v-col> -->
      <v-col cols="12" md="3" class="d-none d-md-block">
        <highlights-widget :excluded-ids="excludedIds" hide-title-X :per-page="10"></highlights-widget>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'HomeHeroTwo',

    props: {
      featuredPosts: {
        type: Array,
        default: () => ([])
      },
      numberOfItems: {
        type: Number,
        default: 5
      }
    },

    computed: {
      featuredPost() {
        return _.head(this.featuredPosts)
      },
      otherItems() {
        return this.featuredPosts.slice(1,this.numberOfItems)
      },
      excludedIds() {
        return _.map(this.featuredPosts, 'id')
      },
      today() {
        let date = new Date()
        let weekday = date.toLocaleString('en-GB', { weekday: 'long' })
        let year    = date.toLocaleString('en-GB', { year: 'numeric' })
        let month   = date.toLocaleString('en-GB', { month: 'long' })
        let day     = this.ordinal( date.toLocaleString('en-GB', { day: 'numeric' }) )
        return weekday + ' ' + day + ' ' + month + ' ' + year
      }
    },

    methods: {
      ordinal(n) {
        let s = ["th", "st", "nd", "rd"];
        let v = n%100;
        return n + (s[(v-20)%10] || s[v] || s[0]);
      },
    }
  }
</script>

<style lang="sass">
  .ch-post__subtitle
    font-size: 1rem
    font-weight: 400
    line-height: 1.5rem
    letter-spacing: 0.008em
</style>